import React from 'react';
import { Col, Row } from 'reactstrap';

const TicketDescription = (props) => {
    const { data } = props;

    return (
        <div>
            {
                console.log('DATA', data)
            }
            <Row>
                <Col xl='6' lg='6' md='6' sm='12' xs='12'>
                    <Row style={{ marginBottom: '1rem', border: '1px solid #D9D9D9', padding: '5px' }}>
                        <Col xl='6' lg='6' md='6' sm='12' xs='12' style={{ fontWeight: 'bold' }}>Ticket ID:</Col>
                        <Col xl='6' lg='6' md='6' sm='12' xs='12'>{data.ticket_id}</Col>
                    </Row>
                    <Row style={{ marginBottom: '1rem', border: '1px solid #D9D9D9', padding: '5px' }}>
                        <Col xl='6' lg='6' md='6' sm='12' xs='12' style={{ fontWeight: 'bold' }}>Date:</Col>
                        <Col xl='6' lg='6' md='6' sm='12' xs='12'>{data.date}</Col>
                    </Row>
                    <Row style={{ marginBottom: '1rem', border: '1px solid #D9D9D9', padding: '5px' }}>
                        <Col xl='6' lg='6' md='6' sm='12' xs='12' style={{ fontWeight: 'bold' }}>Category:</Col>
                        <Col xl='6' lg='6' md='6' sm='12' xs='12'>{data.category}</Col>
                    </Row>
                    <Row style={{ marginBottom: '1rem', border: '1px solid #D9D9D9', padding: '5px' }}>
                        <Col xl='6' lg='6' md='6' sm='12' xs='12' style={{ fontWeight: 'bold' }}>Status:</Col>
                        <Col xl='6' lg='6' md='6' sm='12' xs='12'>{data.status}</Col>
                    </Row>
                    <Row style={{ marginBottom: '1rem', border: '1px solid #D9D9D9', padding: '5px' }}>
                        <Col xl='6' lg='6' md='6' sm='12' xs='12' style={{ fontWeight: 'bold' }}>Ticket Status:</Col>
                        <Col xl='6' lg='6' md='6' sm='12' xs='12'>{data.ticket_status}</Col>
                    </Row>
                </Col>
                <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                    <Row style={{ marginBottom: '1rem', border: '1px solid #D9D9D9', padding: '5px' }}>
                        <Col xl='3' lg='3' md='3' sm='12' xs='12' style={{ fontWeight: 'bold' }}>Description of issue:</Col>
                        <Col xl='9' lg='9' md='9' sm='12' xs='12'>{data.description}</Col>
                    </Row>
                </Col>
                {
                    (data?.status == 'Resolved' || data?.status == 'resolved') &&
                    (
                        <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                            <Row style={{ marginBottom: '1rem', border: '1px solid #D9D9D9', padding: '5px' }}>
                                <Col xl='3' lg='3' md='3' sm='12' xs='12' style={{ fontWeight: 'bold' }}>Resolution Summary:</Col>
                                <Col xl='9' lg='9' md='9' sm='12' xs='12'>{data.description}</Col>
                            </Row>
                        </Col>
                    )
                }
            </Row>
        </div>
    );
};

export default TicketDescription;
